import React from 'react';
import { Lock, ShieldCheck, CheckCircle } from 'lucide-react';
import { motion } from 'framer-motion';
export function CTASection() {
  return <div className="w-full max-w-xl mx-auto px-4 flex flex-col items-center" data-id="element-93">
      <motion.a href="https://pay.hotmart.com/H105591567U?checkoutMode=10" whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className="w-full bg-gradient-to-r from-[#B8860B] via-[#D4AF37] to-[#B8860B] text-black font-inter font-bold text-lg sm:text-xl py-5 rounded-xl shadow-[0_0_20px_rgba(212,175,55,0.2)] hover:shadow-[0_0_30px_rgba(212,175,55,0.4)] transition-all duration-300 uppercase tracking-wide text-center block" data-id="element-94">
        Hacer Mi Limpia Ahora
      </motion.a>

      <div className="flex flex-wrap justify-center items-center gap-x-4 sm:gap-x-6 gap-y-2 mt-4 text-[10px] sm:text-xs text-gray-400 font-inter" data-id="element-95">
        <div className="flex items-center gap-1.5" data-id="element-96">
          <Lock className="w-3.5 h-3.5 text-[#D4AF37]" data-id="element-97" />
          <span data-id="element-98">Pago Seguro SSL</span>
        </div>
        <div className="flex items-center gap-1.5" data-id="element-99">
          <ShieldCheck className="w-3.5 h-3.5 text-[#D4AF37]" data-id="element-100" />
          <span data-id="element-101">Privacidad Protegida</span>
        </div>
        <div className="flex items-center gap-1.5" data-id="element-102">
          <CheckCircle className="w-3.5 h-3.5 text-[#D4AF37]" data-id="element-103" />
          <span data-id="element-104">Satisfacción Garantizada</span>
        </div>
      </div>
    </div>;
}